var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.943%",
    y1: "15.943%",
    x2: "86.442%",
    y2: "86.442%",
    id: "xd5x3koira"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE9F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EA7B0",
    offset: "99.8%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "13.382%",
    y1: "22.084%",
    x2: "86.615%",
    y2: "88.663%",
    id: "ilnlerfowb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3542",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA0B1A",
    offset: "99.6%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.107%",
    y1: "-1.441%",
    x2: "84.88%",
    y2: "101.422%",
    id: "2obzwp9vcc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D61A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16528C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0 8.836-7.164 16-16 16S0 24.836 0 16 7.164 0 16 0s16 7.164 16 16z",
    fill: "url(#xd5x3koira)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16H16v-3.2h15.678c.21 1.034.322 2.104.322 3.2zM6.43 28.8h19.14a16.058 16.058 0 0 0 3.208-3.2H3.222a16.058 16.058 0 0 0 3.208 3.2zM16 0v3.2h9.57C22.9 1.2 19.594 0 16 0zm12.778 6.4H16v3.2h14.66a15.913 15.913 0 0 0-1.882-3.2zM1.34 22.4H30.66a15.86 15.86 0 0 0 1.02-3.2H.321a15.86 15.86 0 0 0 1.019 3.2z",
    fill: "url(#ilnlerfowb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.164 0 0 7.164 0 16h22.274V1.2C19.874.4 17.783 0 16 0z",
    fill: "url(#2obzwp9vcc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.177 4.867 16.6 7.51l1.636-2.214-.877 2.55 2.524-1.347-1.999 1.95 2.916-.213-2.726.964 2.726.964-2.916-.213 2 1.95-2.525-1.347.877 2.55L16.6 10.89l-.423 2.643-.423-2.643-1.635 2.214.877-2.55-2.525 1.347 2-1.95-2.917.213 2.727-.964-2.727-.964 2.916.213-1.999-1.95 2.525 1.347-.877-2.55 1.635 2.214.423-2.643zm-2.37.108c-2.121-.86-4.61-.29-6.038 1.38-1.428 1.672-1.428 4.018 0 5.69 1.427 1.67 3.917 2.24 6.037 1.38-2.359 1.547-5.614 1.222-7.552-.753-1.939-1.976-1.939-4.968 0-6.944 1.938-1.975 5.193-2.3 7.552-.753z",
    fill: "#FC0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.a858fd9da29d2544eedc37c389215d03.svg";
export { ForwardRef as ReactComponent };